import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { RootState } from "../../../store/store";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { issueApis } from "../../../api/Issue";
import { Card } from "antd";
import StatusTimeLine from "../statusTimeLine/StatusTimeLine";

interface IssueStatusTabProps {
  activeTab: string;
}

const IssueStatusTimeLine: React.FC<IssueStatusTabProps> = ({ activeTab }) => {
  const [timeLineData, setTimeLineData] = React.useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const location = useLocation();
  const locationState = (location.state || {}) as any;
  const { data: IssueListInDetailModal } = useSelector(
    (state: RootState) => state.IssueListInDetailModal
  );
  const projectId =
    locationState.projectId ||
    locationState.id ||
    IssueListInDetailModal?.projectId;
  useEffect(() => {
    if (
      activeTab === "StatusTimeLine" &&
      !hasFetched &&
      IssueListInDetailModal?.id &&
      projectId
    ) {
      getStatusTimeLineData();
    }
  }, [activeTab, hasFetched, IssueListInDetailModal, projectId]);

  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse = await issueApis.fetchIssueStatusTimeline(
        projectId,
        IssueListInDetailModal.id
      );
      const { data, status } = apiResponse;
      if (status) {
        setTimeLineData(data);
        setHasFetched(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (activeTab !== "StatusTimeLine") return null;

  return (
    <Card className="card-bordered mt-3" style={{ padding: "20px 50px" }}>
      <StatusTimeLine transitions={timeLineData} />
    </Card>
  );
};

export default IssueStatusTimeLine;
